module.exports = __webpack_public_path__ + "static/img/e5d24bdd5c9a22d939d028270dddafd.0de7241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/e5d24bdd5c9a22d939d028270dddafd.jpg
// module id = 9Krt
// module chunks = 1